function validateForm(form, options) {
    var el = this;
    el.options = options;
    el.form = form;
    el.inputs = [];
    el.url = '';
    el.submitButton = null;
    el.sending = false;
    el.settings = {
        successMsg: 'Form inviato correttamente',
        sendingMsg: "Invio in corso...",
        question: {
            text: "Sei sicuro?",
            icon: "error",
            buttonsStyling: false,
            showCancelButton: true,
            confirmButtonText: "Continua!",
            cancelButtonText: 'Annulla',
            customClass: {
                confirmButton: "button button-secondary",
                cancelButton: "button button-default"
            }
        },
        onSubmit: function () {
            Swal.fire({
                text: this.sendingMsg,
                showConfirmButton: false,
            });
            el.formData = el.getData(el.formData);
            el.submitForm();
        },
        onServerError: function (data) {
            console.log(data);
            Swal.fire({
                icon: 'error',
                text: "Si è verificato un errore",
                buttonsStyling: false,
                confirmButtonText: "Chiudi",
                customClass: {
                    confirmButton: "button button-default"
                }
            });
        },
        onFormError: function (data) {
            console.log(data);
            if (data.length > 0) {
                Swal.fire({
                    icon: 'error',
                    html: "<p>" + data.join('<br>') + "</p>",
                    buttonsStyling: false,
                    confirmButtonText: "Chiudi",
                    customClass: {
                        confirmButton: "button button-default"
                    }
                });
            }
        },
        onSuccess: function (data) {
            console.log(data);
            Swal.fire({
                icon: 'success',
                html: this.successMsg,
                buttonsStyling: false,
                confirmButtonText: "Chiudi",
                customClass: {
                    confirmButton: "button button-primary"
                }
            }).then((result) => {
                el.settings.onSuccessAlertClose(data);
            });
        },
        onSuccessAlertClose: function (data) {
            console.log(data);
        }
    };
    el.data = {
        parent: 'data-form-parent',
        error: 'data-form-error',
        submit: 'data-form-submit',
        question: 'data-form-question',
        hint: 'data-form-hint'
    };
    el.sels = {
        parent: '[' + el.data.parent + ']',
        error: '[' + el.data.error + ']',
        submit: '[' + el.data.submit + ']',
        question: '[' + el.data.question + ']',
        hint: '[' + el.data.hint + ']',
    };
    el.formData = new FormData();

    el.init = function () {
        var q = $.extend(el.settings.question, el.options.question);
        $.extend(el.settings, el.options);
        el.settings.question = q;
        el.getInputs();
        el.url = $(el.form).attr('action');
        el.submitButton = $(el.form).find(el.sels.submit);
        el.questionButton = $(el.form).find(el.sels.question);
        $(el.inputs).each(function () {
            var element = this;
            $(this.input).on('blur', function () {
                el.validateInput(element);
            });
            $(this.input).on('change', function () {
                el.validateInput(element);
            });
        });
        $(el.submitButton).on('click', function () {
            if (el.validate()) {
                el.settings.onSubmit();
            }
        });
        $(el.form).on('keypress', function(e) {
            if(e.which == 13){
                e.preventDefault();
                if (el.validate()) {
                    el.settings.onSubmit();
                }
            }
        });
        $(el.questionButton).on('click', function () {
            el.question();
        });
    };

    el.getInputs = function () {
        $(el.form).find(el.sels.parent).each(function () {
            var input = $(this).find('input').length ? $(this).find('input') : ($(this).find('select').length ? $(this).find('select') : $(this).find('textarea'));
            var par = this;
            $(input).each(function () {
                if ($(this).attr('type') != 'hidden') {
                    $(this).on('blur', function () {
                        el.validateInput(obj);
                    });
                    var obj = {
                        input: this,
                        parent: par,
                        error: $(par).find(el.sels.error),
                        name: $(this).attr('name')
                    };
                    if ($(this).attr('data-input-date-min') !== undefined) {
                        var min = parseInt($(this).attr('data-input-date-min'));
                        var max = parseInt($(this).attr('data-input-date-max'));
                        var span = parseInt($(this).attr('data-input-date-span'));
                        var value = parseInt($(this).attr('data-input-value'));
                        var valuemin = parseInt($(this).attr('data-input-valuemin'));
                        var valuemax = parseInt($(this).attr('data-input-valuemax'));
                        var opt = {
                            singleDatePicker: true,
                            showDropdowns: true,
                            locale: {
                                format: "DD/MM/YYYY",
                                separator: " - ",
                                applyLabel: "Applica",
                                cancelLabel: "Annulla",
                                fromLabel: "Da",
                                toLabel: "A",
                                customRangeLabel: "Personalizzato",
                                weekLabel: "W",
                                daysOfWeek: ["Do", "Lu", "Ma", "Me", "Gi", "Ve", "Sa"],
                                monthNames: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
                                firstDay: 1
                            },
                        }
                        if (value > 0) {
                            opt.startDate = moment(value * 1000);
                        }
                        if (valuemin > 0 && valuemax) {
                            opt.startDate = moment(valuemin * 1000);
                            opt.endDate = moment(valuemax * 1000);
                        }
                        if ($(this).attr('data-input-date-span') != undefined) {
                            opt.singleDatePicker = false;
                        }
                        if ($(this).attr('data-input-time') != undefined) {
                            opt.timePicker = true;
                            opt.timePicker24Hour = true;
                            opt.locale.format = "DD/MM/YYYY HH:mm";
                        }
                        if (span > 0) {
                            opt.maxSpan = { days: span };
                        }
                        if (min > 0) {
                            opt.minDate = moment(min * 1000);
                        }
                        if (max > 0) {
                            opt.maxDate = moment(max * 1000);
                        }
                        $(this).daterangepicker(opt);
                        $(this).val("");
                    }
                    el.inputs[el.inputs.length] = obj;
                }
            });
        });
    };

    el.validateInput = function (element) {
        var value = $(element.input).val();
        var msg = el.validateValue(element.input, value);
        var valid = msg === true;
        el.setInputError(element, valid, msg);
        return valid;
    };

    el.validateValue = function (input, value) {
        var required = $(input).attr('required') !== undefined;
        var maxlength = parseInt($(input).attr('data-form-maxlength'));
        var min = parseInt($(input).attr('data-form-min'));
        var max = parseInt($(input).attr('data-form-max'));
        var msg = true;
        if (value == undefined || value == null || value == '') {
            if (required) {
                msg = formErrors.required;
            }
        }
        else {
            if (($(input).attr('type') == 'number' || $(input).attr('data-form-type') == 'number') && isNaN(value)) {
                msg = formErrors.number;
            }
            else if ($(input).attr('type') == 'url' && !/(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/.test(value)) {
                msg = formErrors.url;
            }
            else if ($(input).attr('type') == 'email' && !/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(value)) {
                msg = formErrors.email;
            }
            else if ($(input).attr('data-newpassword') != undefined && !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/g.test(value)) {
                msg = formErrors.newpassword;
            }
            else if($(input).attr('data-equals') != undefined && $($(input).attr('data-equals')).val() != value){
                msg = formErrors.equals;
            }
            else if(maxlength > 0 && value.length > maxlength){
                msg = formErrors.maxlength.replace("{num}", maxlength);
            }
            else if(min > 0 && Number(value) < min){
                msg = formErrors.min.replace("{num}", min);
            }
            else if(max > 0 && Number(value) > max){
                msg = formErrors.max.replace("{num}", max);
            }
        }
        return msg;
    };

    el.setInputError = function (element, valid, msg, server) {
        if (valid) {
            if (server || !$(element.parent).hasClass('server-error')) {
                $(element.parent).removeClass('invalid');
                $(element.error).text('');
            }
        }
        else {
            $(element.parent).addClass('invalid');
            $(element.error).text(msg);
            if (server) {
                $(element.parent).addClass('server-error');
            }
        }
    };

    el.validate = function () {
        var valid = true;
        $(el.inputs).each(function () {
            var v = el.validateInput(this);
            valid = valid ? v : valid;
        });
        return valid;
    };

    el.getData = function (formData) {
        $(el.inputs).each(function () {
            if ($(this.input).attr('type') == 'file' && this.input.files.length > 0 && !$(this.input).is(':disabled')) {
                formData.append($(this).attr('name'), this.input.files[0]);
            }
            else if ($(this.input).attr('type') == 'checkbox') {
                if ($(this.input).is(':checked') && !$(this.input).is(':disabled'))
                    formData.append(this.name, $(this.input).val());
            }
            else if(!$(this.input).is(':disabled')) {
                formData.append(this.name, $(this.input).val());
            }
        });
        $(el.form).find('input[type=hidden]').each(function () {
            formData.append($(this).attr('name'), $(this).val());
        });
        return formData;
    };

    el.validateServer = function (data) {
        var formerrors = [];
        $(data.errors).each(function () {
            if (this.type == 1) {
                var error = this;
                $(el.inputs).each(function () {
                    if (this.name == error.name) {
                        el.setInputError(this, false, error.msg, true);
                    }
                });
            }
            else {
                formerrors[formerrors.length] = '<li>' + this.msg + '</li>';
            }
        });
        return formerrors;
    };

    el.submitForm = function () {
        if (!el.sending) {
            el.sending = true;
            $.ajax({
                type: 'POST',
                url: el.url,
                data: el.formData,
                dataType: 'json',
                cache: false,
                contentType: false,
                processData: false,
                success: function (data) {
                    Swal.close();
                    if (data.id) {
                        el.settings.onSuccess(data);
                    }
                    else {
                        var errors = el.validateServer(data);
                        el.settings.onFormError(errors);
                    }
                    el.sending = false;
                },
                error: function (err) {
                    el.sending = false;
                    el.settings.onServerError(err);
                }
            });
        }
    };

    el.question = function () {
        Swal.fire(el.settings.question).then((result) => {
            if (result.isConfirmed) {
                el.settings.onSubmit();
            }
        });
    }

    el.setOptions = function(options){
        el.options = options;
    }

    return el;
}